const SUPPORTED_LOCALES = ["ru", "en", "es", "tr", "cn"];

const localeAliases = {
	zh: "cn",
	"zh-hans": "cn",
	"zh-cn": "cn",
	"zh-hant": "cn",
};

const normalizeLocale = (locale) => {
	if (!locale || typeof locale !== "string") {
		return "en";
	}

	const lower = locale.toLowerCase();
	if (SUPPORTED_LOCALES.includes(lower)) {
		return lower;
	}
	if (localeAliases[lower]) {
		return localeAliases[lower];
	}

	const base = lower.split("-")[0];
	if (SUPPORTED_LOCALES.includes(base)) {
		return base;
	}
	if (localeAliases[base]) {
		return localeAliases[base];
	}

	return "en";
};

export {
	SUPPORTED_LOCALES,
	normalizeLocale,
};
